/* global Phaser, game */

Game.States.Menu = {

	/**
	 * Create menu
	 */
	create: function() {

		game.sound.stopAll();

		var logo = game.add.sprite( game.width / 2, game.height / 2, 'intro' );
		logo.anchor.setTo( 0.5, 0.5 );

		// Start the game when the screen is tapped
		game.input.onDown.addOnce( this.start, this );

		game.camera.flash( 0xffffff, 1000 );

		// Game.Utils.Audio.fade_in( 'menu', 1500, true );

	},

	/**
	 * Method to call on game start.
	 */
	start: function() {

		window.focus();

		game.state.start(
			'load-world',
			true,
			false,
			{
				type: 'world',
				path: 'world'
			}
		);

	}

};
